import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import http from "../http";

//不要写在initalState里
let localSearchFromStorage = JSON.parse(window.localStorage.getItem('localSearch')) || [];
if (localSearchFromStorage.length > 10) {
    localSearchFromStorage.length = 10
    window.localStorage.setItem('localSearch', JSON.stringify(localSearchFromStorage));

}
const initialState = {
    loading: false,
    searchValue: '',//header里的搜索关键字
    searchObject: '',//mapData里的对象（村）
    homeSearchValue: '',//header里的搜索关键字
    localSearch: localSearchFromStorage,
    recommandSearch: [],//推荐搜索
}

export const fetchRecommand = createAsyncThunk('keyword', async () => {
    const response = await http.post("/v1/keyword")
    return response.data
})

const slice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        updateSearch(state, action) {
            console.log('更新本地内容', action);
            state.localSearch.push(action.payload);
            window.localStorage.setItem('localSearch', JSON.stringify([...state.localSearch, action.payload]));
        },
        updateSearchValue(state, action) {
            state.searchValue = action.payload;
        },
        updateHomeSearchValue(state, action) {
            state.homeSearchValue = action.payload;
        },
        updateSearchObject(state, action) {
            state.searchObject = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchRecommand.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRecommand.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.isSuccess == 1) {
                    state.recommandSearch = action.payload.item;
                }
                else {
                    // state.data = null;
                }

            })
            .addCase(fetchRecommand.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
})

export const { updateSearch,updateSearchObject, updateSearchValue,updateHomeSearchValue } = slice.actions

export default slice.reducer